"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HypertensionRecord = void 0;
class HypertensionRecord {
    constructor(props) {
        this.activity = props?.activity || {
            discussion: props?.activity?.discussion || false,
            excersise: props?.activity?.excersise || false,
            food: props?.activity?.food || false
        };
        this.monitoring = props?.monitoring || "hypertension";
        this.other_activity = props?.other_activity || "";
        this.patient = props?.patient || {
            uid: props?.patient?.uid
        };
        this.result = props?.result;
        this.values = props?.values || {
            diastolic: props?.values?.diastolic,
            measure_spot: props?.values?.measure_spot || "",
            systolic: props?.values?.systolic
        };
        this.timestamp = props?.timestamp;
    }
}
exports.HypertensionRecord = HypertensionRecord;
